import React from "react";
import { Link } from "react-router-dom";

import "../../Styles/BoxPlural.css";

const BoxPlural = ({ coins, scores }) => {
  return (
    <div className="BoxPlural_wrapper">
      <div className="BoxPlural_inside-item-image">
        <img className="BoxPlural_inside-image" src="/imgs/Common/Plural.svg" />
      </div>

      <div className="BoxPlural_inside">
        <div className="BoxPlural_inside-border">
          <div className="BoxPlural_inside-border-inside">
            <p>جمع کل سکه ها</p>
            <p className="number-font">{coins}</p>
          </div>
          <div className="BoxPlural_inside-border-center"></div>
          <div className="BoxPlural_inside-border-inside">
            <p>جمع کل امتیازها</p>
            <p className="number-font">{scores}</p>
          </div>
        </div>
      </div>
      <div className="BoxPlural_inside-item-buttom">
        <Link
          to="/hisstori/club"
          className="BoxPlural_inside-item-buttom-border"
        >
          برو تو باشگاه
        </Link>
      </div>
    </div>
  );
};
export default BoxPlural;
